import { Signal } from '@preact/signals';

const shopify = globalThis.shopify;
if (shopify && typeof shopify.setSignals === 'function') {
  shopify.setSignals(Signal);
}
